module.exports = __webpack_public_path__ + "static/img/10.45859da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/10.png
// module id = nStX
// module chunks = 0